export function parseLocation(location = "us") {
    switch (location) {
        case "eu-residency":
        case "in-residency":
        case "us":
        case "global":
            return location;
        default:
            console.warn(`[ElevenAgents] Invalid server-location: ${location}. Defaulting to "us"`);
            return "us";
    }
}
export function getOriginForLocation(location) {
    const originMap = {
        us: "wss://api.elevenlabs.io",
        "eu-residency": "wss://api.eu.residency.elevenlabs.io",
        "in-residency": "wss://api.in.residency.elevenlabs.io",
        global: "wss://api.elevenlabs.io",
    };
    return originMap[location];
}
export function getLivekitUrlForLocation(location) {
    const livekitUrlMap = {
        us: "wss://livekit.rtc.elevenlabs.io",
        "eu-residency": "wss://livekit.rtc.eu.residency.elevenlabs.io",
        "in-residency": "wss://livekit.rtc.in.residency.elevenlabs.io",
        global: "wss://livekit.rtc.elevenlabs.io",
    };
    return livekitUrlMap[location];
}
//# sourceMappingURL=location.js.map